// extracted by mini-css-extract-plugin
export var cardHeader = "_s0-0";
export var reorderHandle = "_s0-3";
export var titleArea = "_s0-1";
export var titleAreaWithHandle = "_s0-2";